import { VerificationPhase } from './back-requirement';

export const resolveAlwaysRequiredBack = () => ({
  isBackRequired: true,
  showBackUpload: true,
  verificationPhase: VerificationPhase.AWAITING_BOTH,
});
